import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Avatar } from "antd";
import { useUserSession } from "./user-context";
import { Spin as Hamburger } from 'hamburger-react'
import menu from '../assets/img/menu.jpg'

function Sidebar({ routes, toggle,toggleHandler1 }) {
  const navigate = useNavigate();
  // const [name, setName] = useState(localStorage.getItem("user_namefamily"));
  const [user1, setUser1] = useState(localStorage.getItem("user_namefamily"))
  const [image, setImage] = useState(localStorage.getItem("user_profile"));
  const { user } = useUserSession();

  useEffect(() => {
    setUser1(localStorage.getItem("user_namefamily"));
  }, [user])

  const exitHandler = (e) => {
    localStorage.removeItem("user_token");
    localStorage.clear();
    navigate("/");
  };




  return (
    <div className="rgc-main-side">

      <div
        className={toggle ? "l-navbar show" : "l-navbar"}
        id="nav-bar"
      >
        <nav className="nav">
          <div>
            <div className="header_toggle d-none d-lg-block" style={{color: "#6c757d"}}>
              <Hamburger
                toggled={toggle}
                toggle={toggleHandler1}
                size={27}
                rounded={true}
              />
            </div>
            <div className="d-block d-lg-none">
              <NavLink to="profile" aria-current="page">
                <div className="d-flex nav_logo justify-content-start">
                  <Avatar
                    className="fa fa-user-circle rgc-avatar"
                    size="large"
                    src={image}
                  />
                  <div>
                    {!user.Islogin ? (
                      <div className="style-nav m-3">
                        {user1}
                      </div>
                    ) : (
                      <div className="style-nav m-3">
                        {user1}
                      </div>
                    )}
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="nav_list">
              {routes.map((prop, key) => {
                if (!prop.redirect && prop.layout === "menu")
                  return (
                    <li key={key} onClick={toggleHandler1}>
                      <NavLink
                        to={prop.path}
                        className="nav_link active"
                        onClick={toggleHandler1}

                      >
                        <i className={prop.icon} />
                        <span className="nav_name">{prop.name}</span>
                      </NavLink>
                    </li>
                  );
                return null;
              })}

              <div className="nav_link" onClick={(e) => exitHandler(e)}>
                <i className="fas fa-power-off fa-fw  nav_icon"></i>
                <span className="nav_name">خروج</span>
              </div>

              <div className="rgc-sidebar-img">
                <img src={menu} alt="" />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;
